import { Highlight } from 'prism-react-renderer'
import Prism from 'prismjs'
import 'prismjs/components/prism-bash'
import 'prismjs/components/prism-json'
import 'prismjs/components/prism-jsx'
import 'prismjs/components/prism-markup'
import 'prismjs/components/prism-powershell'
import 'prismjs/components/prism-python'
import 'prismjs/components/prism-ruby'
import 'prismjs/components/prism-sql'
import 'prismjs/components/prism-tsx'
import 'prismjs/components/prism-typescript'
import 'prismjs/components/prism-yaml'
import type { RepositoryFile } from '@/frontend/features/Fde/types'

export default function RepositoryCodeViewer({ file }: { file: RepositoryFile }) {
  const language = file.language || 'text'
  return <Highlight prism={Prism} code={file.content || ''} language={language}>
    {({ tokens, getLineProps, getTokenProps }) => <pre className="agent-code min-h-full min-w-max bg-muted/15 p-6 font-mono text-[13px] leading-6 text-foreground">
      <code>{tokens.map((line, lineIndex) => {
        const { style: _style, ...lineProps } = getLineProps({ line })
        return <span key={lineIndex} {...lineProps} className="block min-h-6"><span className="mr-5 inline-block w-8 select-none text-right text-muted-foreground/45">{lineIndex + 1}</span>{line.map((token, tokenIndex) => {
          const { style: _tokenStyle, ...tokenProps } = getTokenProps({ token })
          return <span key={tokenIndex} {...tokenProps} />
        })}</span>
      })}</code>
    </pre>}
  </Highlight>
}
